export default __webpack_public_path__ + "static/media/five.c4b5c48e.png";